module.exports = __webpack_public_path__ + "img/call_missed.fa180701.svg";